module.exports = __webpack_public_path__ + "img/horizontal_7_7_pp23_7042.0efaec4a.png";